var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download_outline_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE2\x86\xB3 Icon Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C12.4971 2 12.9 2.40294 12.9 2.9V13.8272L17.4636 9.26361C17.8151 8.91214 18.3849 8.91214 18.7364 9.26361C19.0879 9.61508 19.0879 10.1849 18.7364 10.5364L12.6364 16.6364C12.2849 16.9879 11.7151 16.9879 11.3636 16.6364L5.26361 10.5364C4.91214 10.1849 4.91214 9.61508 5.26361 9.26361C5.61508 8.91214 6.18493 8.91214 6.5364 9.26361L11.1 13.8272V2.9C11.1 2.40294 11.5029 2 12 2ZM4 20C4 19.5029 4.40294 19.1 4.9 19.1H19.1C19.5971 19.1 20 19.5029 20 20C20 20.4971 19.5971 20.9 19.1 20.9H4.9C4.40294 20.9 4 20.4971 4 20Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.c6b47524e01f5c4d5c782d3d6529fd14.svg";
export { ForwardRef as ReactComponent };